import { ROUTES } from "@/shared/config";

export const TUTORIAL_ATTRIBUTE = "data-tutorial";

export const TUTORIAL_ANCHORS = {
    BALANCE: "balance",
    CREATE_CAMPAIGN: "create-campaign",
    CAMPAIGNS: "campaigns",
    REPORTS: "reports",
    ASSETS: "assets",
    CREATIVES: "creatives",
    HELP: "help",
} as const;

export type TutorialAnchor = (typeof TUTORIAL_ANCHORS)[keyof typeof TUTORIAL_ANCHORS];

/** Sidebar item key (route) -> tutorial anchor */
export const SIDEBAR_TUTORIAL_ANCHORS: Record<string, TutorialAnchor> = {
    [ROUTES.CAMPAIGNS]: TUTORIAL_ANCHORS.CAMPAIGNS,
    "/reports": TUTORIAL_ANCHORS.REPORTS,
    "/assets": TUTORIAL_ANCHORS.ASSETS,
    "/creatives": TUTORIAL_ANCHORS.CREATIVES,
};

export const getTutorialSelector = (anchor: TutorialAnchor) =>
    `[${TUTORIAL_ATTRIBUTE}="${anchor}"]`;

/** Spread onto an element to make it a tutorial anchor: <div {...tutorialAnchor("balance")} /> */
export const tutorialAnchor = (anchor?: TutorialAnchor) =>
    anchor ? { [TUTORIAL_ATTRIBUTE]: anchor } : {};
